import { FC, ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";
export interface LanguageProps {
	children?: ReactNode;
}

export interface LanguageComponent extends FC<LanguageProps> {}

export const Language: LanguageComponent = ({ children }) => {
	const { i18n } = useTranslation();

	useEffect(() => {
		const savedLanguage = localStorage.getItem("language");
		if (savedLanguage) {
			i18n.changeLanguage(savedLanguage);
		}
	}, []);

	useEffect(() => {
		localStorage.setItem("language", i18n.language);
	}, [i18n.language]);

	return <>{children}</>;
};
